// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".all-about[data-v-1705e51a]{display:flex;justify-content:space-between;margin:25px 0;width:100%}.delivery-wrapper[data-v-1705e51a]{display:flex;flex-direction:column;width:100%}@media screen and (max-width:1050px){.attributes[data-v-1705e51a]{margin-left:0}.desktop-description[data-v-1705e51a]{display:none}.all-about[data-v-1705e51a]{flex-direction:column}.mobile-delivery[data-v-1705e51a]{display:block}}", ""]);
// Exports
module.exports = exports;
